import {
  Box,
  Card,
  Checkbox,
  Chip,
  List,
  ListItem,
  makeStyles,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  withStyles,
  Fade
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { Pagination } from '@material-ui/lab';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useSelector } from 'react-redux';
import DialogConfirm from 'src/app/components/DialogConfirm';
import { MESSAGE } from 'src/app/constant/message';
import { deleteStaff } from 'src/features/staffSlice';
import { updateUser } from 'src/features/userSlice';
import { closeDialogConfirm, showDialogConfirm } from 'src/features/uiSlice';
import { useDispatch } from 'react-redux';
import LoadingComponent from 'src/app/components/Loading';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';
import EditStaff from './EditStaff';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    whiteSpace: 'nowrap'
  },
  body: {
    fontSize: 14,
    whiteSpace: 'nowrap'
  },
  root: {
    padding: '6px'
  }
}))(TableCell);

const Results = ({ listStaff, getListStaffRef, params, setParams }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.staffSlice.isLoading);
  const totalStaffs = useSelector(state => state.staffSlice.totalStaffs);
  const isLeadMarketing = useSelector(state => state.authSlice.isLeadMarketing);
  const isAdmin = useSelector(state => state.authSlice.isAdmin);
  const classes = useStyles();
  const [limit, setLimit] = useState(PAGE_SIZE_LIST);
  const [page, setPage] = useState(1);
  const [selectedItem, setSelectedItem] = useState();
  const [itemCurrent, setItemCurrent] = useState();
  const [rowsSelected, setRowsSelected] = useState([]);
  const [confirmAction, setConfirmAction] = useState(null); // 'delete' | 'disable' | 'enable'

  const [anchorEl, setAnchorEl] = React.useState(null);
  const staffMembers = Array.isArray(listStaff) ? listStaff : [];

  const handleClickMenu = (event, staff) => {
    setAnchorEl(event.currentTarget);
    setItemCurrent(staff);
    setSelectedItem(staff.id);
  };
  const [openEditModal, setOpenEditModal] = useState(false);

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const handleEditStaff = () => {
    setOpenEditModal(true);
    handleCloseMenu();
  };

  const closeModal = () => {
    setOpenEditModal(false);
  };

  const handleDeleteStaff = () => {
    setConfirmAction('delete');
    dispatch(showDialogConfirm());
    handleCloseMenu();
  };

  const handleDeleteMultiStaff = () => {
    setConfirmAction('delete');
    dispatch(showDialogConfirm());
    handleCloseMenu();
  };

  const handleDisableStaff = () => {
    setConfirmAction('disable');
    dispatch(showDialogConfirm());
    handleCloseMenu();
  };

  const handleEnableStaff = () => {
    setConfirmAction('enable');
    dispatch(showDialogConfirm());
    handleCloseMenu();
  };

  const confirmDelete = () => {
    const listId = rowsSelected?.length > 0 ? rowsSelected : [selectedItem];
    setRowsSelected([]);
    dispatch(closeDialogConfirm());
    listId.forEach(id => dispatch(deleteStaff({ id })));
  };

  const confirmDisable = () => {
    if (!itemCurrent?.id) return;
    dispatch(closeDialogConfirm());
    dispatch(updateUser({ id: itemCurrent.id, data: { status: 3 } })).then(action => {
      if (updateUser.fulfilled.match(action) && getListStaffRef) {
        getListStaffRef(params);
      }
    });
  };

  const confirmEnable = () => {
    if (!itemCurrent?.id) return;
    dispatch(closeDialogConfirm());
    dispatch(updateUser({ id: itemCurrent.id, data: { status: 1 } })).then(action => {
      if (updateUser.fulfilled.match(action) && getListStaffRef) {
        getListStaffRef(params);
      }
    });
  };

  const handleConfirmOk = () => {
    if (confirmAction === 'disable') {
      confirmDisable();
    } else if (confirmAction === 'enable') {
      confirmEnable();
    } else {
      confirmDelete();
    }
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    if (!getListStaffRef) return;
    const newparams = Object.assign({}, params, { page: newPage });
    setParams(newparams);
    getListStaffRef(newparams);
  };

  const checked = id => {
    return rowsSelected.indexOf(id) !== -1;
  };
  const select = driver => {
    if (rowsSelected.indexOf(driver) === -1) {
      const newSelected = [driver, ...rowsSelected];
      setRowsSelected(newSelected);
    } else {
      const newSelected = rowsSelected.filter(i => i !== driver);
      setRowsSelected(newSelected);
    }
  };

  const checkAll = () => {
    if (rowsSelected.length > 0) {
      setRowsSelected([]);
    }

    if (
      staffMembers.length > 0 &&
      rowsSelected.length !== staffMembers.length
    ) {
      const all = staffMembers.map(item => {
        return item.id;
      });
      setRowsSelected(all);
    }
  };

  return (
    <>
      {openEditModal && (
        <EditStaff
          open={openEditModal}
          staff={itemCurrent}
          onClose={closeModal}
        />
      )}

      <DialogConfirm
        title={
          confirmAction === 'disable'
            ? MESSAGE.CONFIRM_DISABLE_STAFF
            : confirmAction === 'enable'
            ? MESSAGE.CONFIRM_ENABLE_STAFF
            : MESSAGE.CONFIRM_DELETE_STAFF
        }
        textOk={MESSAGE.BTN_YES}
        textCancel={MESSAGE.BTN_CANCEL}
        content={
          confirmAction === 'disable'
            ? `Bạn có chắc chắn muốn vô hiệu hóa tài khoản "${itemCurrent?.full_name || itemCurrent?.phone || ''}" không ?`
            : confirmAction === 'enable'
            ? `Bạn có chắc chắn muốn khôi phục tài khoản "${itemCurrent?.full_name || itemCurrent?.phone || ''}" không ?`
            : MESSAGE.CONTENT_DELETE_STAFF
        }
        callbackOk={handleConfirmOk}
        callbackCancel={() => dispatch(closeDialogConfirm())}
      />

      <Card className={clsx(classes.root)}>
        <div>
          {rowsSelected.length > 0 && (
            <Fade in={rowsSelected.length > 0}>
              <Box
                minWidth={1050}
                style={{ fontSize: '14px', padding: '6px 4px' }}
              >
                <span>
                  <Checkbox
                    checked={rowsSelected.length > 0}
                    onChange={() => checkAll()}
                    color="primary"
                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                  />
                </span>

                <span
                  onClick={handleDeleteMultiStaff}
                  className="mx-2 btnDevice"
                  color="primary"
                  variant="outlined"
                  size="small"
                >
                  <img
                    src={`/static/iconSvg/delete-icon.svg`}
                    alt="delete"
                    style={{ paddingRight: '5px', paddingBottom: '4px' }}
                  />
                  <span className="pt-1"> Xóa </span>
                </span>
              </Box>
            </Fade>
          )}
          <PerfectScrollbar>
            {staffMembers && staffMembers.length ? (
              <Box minWidth={1050}>
                <Table>
                  {rowsSelected.length === 0 && staffMembers?.length > 0 && (
                    <TableHead>
                      <TableRow>
                        <StyledTableCell width={50}>
                          <Checkbox
                            checked={rowsSelected.length > 0}
                            onChange={() => checkAll()}
                            color="primary"
                            inputProps={{
                              'aria-label': 'secondary checkbox'
                            }}
                          />
                        </StyledTableCell>
                        <StyledTableCell>Tên nhân viên</StyledTableCell>
                        <StyledTableCell>Số điện thoại</StyledTableCell>
                        <StyledTableCell>Email</StyledTableCell>
                        <StyledTableCell>Địa chỉ</StyledTableCell>
                        <StyledTableCell>Chức vụ</StyledTableCell>
                        <StyledTableCell>Ngày tạo</StyledTableCell>
                        <StyledTableCell>Trạng thái</StyledTableCell>
                        {!isLeadMarketing && <StyledTableCell></StyledTableCell>}
                      </TableRow>
                    </TableHead>
                  )}
                  <TableBody>
                    {staffMembers.map((staff, index) => (
                      <TableRow hover key={staff.id}>
                        <StyledTableCell
                          style={{ maxWidth: '20px' }}
                          onClick={() => select(staff?.id)}
                        >
                          <Checkbox
                            checked={checked(staff.id)}
                            onChange={() => select(staff.id)}
                            color="primary"
                            inputProps={{
                              'aria-label': 'secondary checkbox'
                            }}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          {staff?.full_name || '-'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {staff?.phone || '-'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {staff?.email || '-'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {staff?.address || '--'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {staff?.role?.title || '--'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {staff?.created_at ? new Date(staff.created_at).toLocaleDateString() : '--'}
                        </StyledTableCell>
                        <StyledTableCell>
                          <Chip
                            size="small"
                            label={
                              Number(staff?.status) === 3
                                ? 'Vô hiệu hóa'
                                : 'Đang hoạt động'
                            }
                            className={clsx(
                              classes.statusChip,
                              Number(staff?.status) === 3
                                ? classes.statusChipDisabled
                                : classes.statusChipActive
                            )}
                          />
                        </StyledTableCell>
                        {!isLeadMarketing && (
                          <StyledTableCell>
                            <span style={{ color: '#AEB1C5' }}>
                              <MoreVertIcon
                                aria-describedby={`menu-device-${staff?.id}`}
                                className={`cursor-pointer hover-red`}
                                onClick={e => handleClickMenu(e, staff)}
                              />
                            </span>

                            <Popover
                              id={`menu-device-${staff.id}`}
                              className="popover-device"
                              open={open && selectedItem === staff.id}
                              anchorEl={anchorEl}
                              onClose={handleCloseMenu}
                              anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left'
                              }}
                              transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right'
                              }}
                            >
                              <Typography>
                                <List>
                                  <ListItem
                                    onClick={handleEditStaff}
                                    className="border-bottom list-menu-device cursor-pointer"
                                  >
                                    Chỉnh sửa
                                  </ListItem>
                                  {isAdmin && (
                                    Number(staff?.status) === 3 ? (
                                      <ListItem
                                        onClick={handleEnableStaff}
                                        className="border-bottom list-menu-device cursor-pointer"
                                      >
                                        Khôi phục tài khoản
                                      </ListItem>
                                    ) : (
                                      <ListItem
                                        onClick={handleDisableStaff}
                                        className="border-bottom list-menu-device cursor-pointer"
                                      >
                                        Vô hiệu hóa tài khoản
                                      </ListItem>
                                    )
                                  )}
                                  <ListItem
                                    onClick={handleDeleteStaff}
                                    className="cursor-pointer list-menu-device"
                                  >
                                    <span class="text-danger"> Xóa </span>
                                  </ListItem>
                                </List>
                              </Typography>
                            </Popover>
                          </StyledTableCell>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            ) : (
              <div className="text-center pb-5">
                <img src="/static/empty.png" class="justify-content-center" />
                <h4> Danh sách trống </h4>
              </div>
            )}
          </PerfectScrollbar>
        </div>
      </Card>
      {staffMembers && staffMembers.length > 0 && (
        <div class="mt-3 mr-4 float-right">
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '15px'
            }}
          >
            <Typography style={{ fontSize: '14px' }}>
              Tổng: {totalStaffs}
            </Typography>
            <Pagination
              count={Math.ceil(totalStaffs / limit)}
              color="primary"
              size="small"
              onChange={handlePageChange}
              page={Number(params.page)}
              showFirstButton
              showLastButton
            />
          </Box>
        </div>
      )}
    </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  listUser: PropTypes.array.isRequired
};

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    '&.MuiPaper-elevation1': {
      boxShadow: 'none'
    }
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  groupAction: {
    display: 'flex',
    alignItems: 'center',
    '& .action': {
      cursor: 'pointer',
      padding: '0 5px',
      '&:hover': {
        color: '#3f51b5'
      }
    }
  },
  minWithColumn: {
    minWidth: '150px'
  },
  statusChip: {
    height: '24px',
    fontSize: '12.5px',
    fontWeight: 600,
    borderRadius: '6px',
    letterSpacing: '0.2px'
  },
  statusChipActive: {
    backgroundColor: 'rgba(76, 175, 80, 0.12)',
    color: '#2e7d32'
  },
  statusChipDisabled: {
    backgroundColor: 'rgba(244, 67, 54, 0.12)',
    color: '#c62828'
  }
}));

export default Results;
